export const SN_UTIL = 'util'
export const UTIL_STATUS_UPDATED = SN_UTIL + '/STATUS_UPDATED'
export const UTIL_FORCE_SCAN_STATUS_UPDATED = SN_UTIL + '/FORCE_SCAN_STATUS_UPDATED'
export const UTIL_BARCODE_IDENTIFICATION_PREF_UPDATED = SN_UTIL + '/BARCODE_IDENTIFICATION_PREF_UPDATED'
export const UTIL_RECEIVE_BY_FULFILLMENT_UPDATED = SN_UTIL + '/RECEIVE_BY_FULFILLMENT_UPDATED'
